var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "contents" } }, [
    _c(
      "div",
      { staticClass: "contents_wrap" },
      [
        _c("skp-breadcrumbs", {
          on: {
            "page-title": function(val) {
              return (_vm.pageTitle = val)
            }
          }
        }),
        _vm._v(" "),
        _c("h2", { staticClass: "pg_title" }, [_vm._v(_vm._s(_vm.pageTitle))]),
        _vm._v(" "),
        _c(
          "div",
          { style: { display: _vm.mode === "search" ? "block" : "none" } },
          [
            _c("div", { staticClass: "srchTop_wrap" }, [
              _c("article", { staticClass: "srch_basic" }, [
                _c("div", { staticClass: "srch_grup" }, [
                  _c("ul", { staticClass: "w50" }, [
                    _c("li", { staticClass: "tit_150" }, [
                      _vm._v("Contents Type")
                    ]),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        staticClass: "w100-150",
                        attrs: { "data-input-type": "select" }
                      },
                      [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.distinctionType,
                                expression: "distinctionType"
                              }
                            ],
                            staticClass: "slt_white w100",
                            on: {
                              change: [
                                function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.distinctionType = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                                function($event) {
                                  return _vm.clickSearch()
                                }
                              ]
                            }
                          },
                          [
                            _c(
                              "option",
                              { attrs: { value: "SB", selected: "" } },
                              [_vm._v("Service Bulletin")]
                            ),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "MX" } }, [
                              _vm._v("Service Bulletin(Mobile)")
                            ])
                          ]
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _vm.distinctionType == "SB"
                    ? _c("ul", { staticClass: "w50" }, [
                        _c("li", { staticClass: "tit_150" }, [
                          _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.CATEGORY")))
                        ]),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            staticClass: "w100-150",
                            attrs: { "data-input-type": "select" }
                          },
                          [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.categoryStatus,
                                    expression: "categoryStatus"
                                  }
                                ],
                                staticClass: "slt_white w100p",
                                attrs: { id: "categoryStatus" },
                                on: {
                                  change: [
                                    function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.categoryStatus = $event.target
                                        .multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                    function($event) {
                                      return _vm.changeCategory1($event)
                                    }
                                  ]
                                }
                              },
                              [
                                _c(
                                  "option",
                                  { attrs: { value: "", selected: "" } },
                                  [_vm._v("ALL")]
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.categoryComboList, function(item) {
                                  return _vm.categoryComboList.length > 0
                                    ? _c(
                                        "option",
                                        {
                                          key: item.code,
                                          domProps: { value: item.code }
                                        },
                                        [_vm._v(_vm._s(item.codeName))]
                                      )
                                    : _vm._e()
                                })
                              ],
                              2
                            )
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.distinctionType == "SB"
                    ? _c("ul", { staticClass: "w50" }, [
                        _c("li", { staticClass: "tit_150" }, [
                          _vm._v("Guide Type")
                        ]),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            staticClass: "w100-150",
                            attrs: { "data-input-type": "select" }
                          },
                          [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.guideType,
                                    expression: "guideType"
                                  }
                                ],
                                staticClass: "slt_white w100",
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.guideType = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  }
                                }
                              },
                              [
                                _c(
                                  "option",
                                  { attrs: { value: "", selected: "" } },
                                  [_vm._v("Select Guide Type")]
                                ),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "ALL" } }, [
                                  _vm._v("ALL (including five types below)")
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "S" } }, [
                                  _vm._v("S/W & Firmware")
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "A" } }, [
                                  _vm._v("Alternative Parts")
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "O" } }, [
                                  _vm._v("On Site Check Guide")
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "R" } }, [
                                  _vm._v("Repair Information & Tips")
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "M" } }, [
                                  _vm._v("Manufacturing BOM Change")
                                ])
                              ]
                            )
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("ul", { staticClass: "w50" }, [
                    _c("li", { staticClass: "tit_150" }, [_vm._v("Role")]),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        staticClass: "w100-150",
                        attrs: { "data-input-type": "select" }
                      },
                      [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.roleStatus,
                                expression: "roleStatus"
                              }
                            ],
                            staticClass: "slt_white w100",
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.roleStatus = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          [
                            _c(
                              "option",
                              { attrs: { value: "", selected: "" } },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("FIELD.FAST.DURATION.ALL"))
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "1" } }, [
                              _vm._v("Approval")
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "2" } }, [
                              _vm._v("Consent")
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "3" } }, [
                              _vm._v("Post Approval")
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "4" } }, [
                              _vm._v("Parallel Consent")
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "7" } }, [
                              _vm._v("Parallel Approval")
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "9" } }, [
                              _vm._v("Notification")
                            ])
                          ]
                        )
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "srch_grupR" }, [
                  _c("span", { staticClass: "btn" }, [
                    _c(
                      "a",
                      {
                        staticClass: "btn_srch",
                        attrs: { href: "JavaScript:" },
                        on: {
                          click: function($event) {
                            return _vm.clickSearch(1)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.SEARCH")))]
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "grid_wrap" },
              [
                _c("div", { staticClass: "grid_total" }, [
                  _vm._v(_vm._s(_vm.$t("TITLE.TOTAL.COUNT")) + " : "),
                  _c("em", [
                    _vm._v(_vm._s(_vm._f("numberFormat")(_vm.resultCount)))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "btn_wrap" }, [
                  _c(
                    "a",
                    {
                      staticClass: "btn_blue",
                      attrs: { href: "JavaScript:", title: "" },
                      on: {
                        click: function($event) {
                          return _vm.clickDelete()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.DELETE")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "btn_blue",
                      attrs: { href: "JavaScript:", title: "" },
                      on: {
                        click: function($event) {
                          return _vm.clickCreate()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.CREATE")))]
                  )
                ]),
                _vm._v(" "),
                _vm.distinctionType == "SB"
                  ? _c("code-list-grid", {
                      key: _vm.gridKey,
                      ref: _vm.gridId,
                      attrs: {
                        gridId: _vm.gridId,
                        data: _vm.gridData,
                        columns: _vm.columns,
                        options: _vm.options,
                        pageOptions: _vm.pageOptions,
                        click: _vm.contentClick,
                        isTotalCount: false,
                        menuMode: _vm.menuMode
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.distinctionType != "SB"
                  ? _c("code-list-grid", {
                      key: _vm.gridKey,
                      ref: _vm.gridId,
                      attrs: {
                        gridId: _vm.gridId,
                        data: _vm.gridData,
                        columns: _vm.columnsMX,
                        options: _vm.options,
                        pageOptions: _vm.pageOptions,
                        click: _vm.contentClick,
                        isTotalCount: false,
                        menuMode: _vm.menuMode
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _vm.mode == "view"
          ? _c("content-view", { attrs: { pCategoryId: _vm.categoryId } })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1926bd12", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1926bd12","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/admin/knowledgeManager/approval/ApprovalManageList.vue
// module id = c0AX
// module chunks = 0